import { Box, Stack, Typography } from "@mui/material"
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BaseButton from "../BaseButton"

const FamilyMemberMedicalReportsTab = () => {
  return (
    <Box
      sx={{
        my: '20px',
        mx: '2px'
      }}
    >
      <Stack
        spacing={'24px'}
      >
        <Box
          sx={{
            display: 'flex',
            bgcolor: 'primary.lightBlue',
            borderRadius: '4px',
            padding: '12px'
          }}
        >
          <ErrorIcon 
            sx={{
              color: 'primary.red',
              fontSize: '20px',
              mr: '8px'
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography variant="body">
              This user does not have their reports set for public view. In order to view their medical reports, please ask for access.
            </Typography>
              <BaseButton
                buttonType={'default'}
                sx={{
                  mt: '8px',
                  maxWidth: '200px'
                }}
              >
                <Typography variant="body">
                  Ask for view access
                </Typography>
              </BaseButton>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            bgcolor: 'primary.lightBlue',
            borderRadius: '4px',
            padding: '12px'
          }}
        >
          <ErrorIcon 
            sx={{
              color: 'primary.red',
              fontSize: '20px',
              mr: '8px'
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography variant="body">
              Your family administrator User name has asked to access your medical reports. Would you like to allow access? <br />
              (You can always change this in your user settings)
            </Typography>
            <Stack spacing={'8px'} direction={'row'} mt='8px'>
              <BaseButton
                buttonType={'default'}
                sx={{
                  maxWidth: '130px'
                }}
              >
                <Typography variant="body">
                  Decline
                </Typography>
                <CancelIcon 
                  sx={{
                    color: 'primary.red',
                    fontSize: '24px',
                    ml: '8px'
                  }}
                />
              </BaseButton>
              <BaseButton
                buttonType={'primary'}
                sx={{
                  maxWidth: '130px'
                }}
              >
                <Typography variant="body">
                  Allow
                </Typography>
                <CheckCircleIcon 
                  sx={{
                    color: 'primary.darkGreen',
                    fontSize: '24px',
                    ml: '8px'
                  }}
                />
              </BaseButton>
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default FamilyMemberMedicalReportsTab